import * as React from "react";
const SvgFiRrMandolin = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-mandolin_svg__a)">
      <path
        fill="#062147"
        d="M23.542 1.772 22.227.458a1.56 1.56 0 0 0-2.01-.17l-1.209.935a3 3 0 0 0-1.149 2.044l-.183 1.644L15.585 7H8.499C3.813 7 0 10.814 0 15.5c0 2.27.884 4.405 2.49 6.01A8.45 8.45 0 0 0 8.5 24c4.687 0 8.5-3.813 8.5-8.5V8.414l2.091-2.091 1.644-.183a3 3 0 0 0 2.044-1.15l.934-1.208a1.56 1.56 0 0 0-.169-2.01zM15 15.5c0 3.584-2.916 6.5-6.5 6.5a6.46 6.46 0 0 1-4.596-1.903A6.46 6.46 0 0 1 2 15.5C2 11.916 4.916 9 8.5 9h5.086l-3.422 3.422A3.5 3.5 0 0 0 8.5 12C6.57 12 5 13.57 5 15.5S6.57 19 8.5 19s3.5-1.57 3.5-3.5c0-.602-.153-1.17-.422-1.664L15 10.414zm-5 0c0 .827-.673 1.5-1.5 1.5S7 16.327 7 15.5 7.673 14 8.5 14c1.5 0 1.5 1.5 1.5 1.5"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-mandolin_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrMandolin;
